export const ORIENTATION = Object.freeze({
    VERTICAL:   'vertical',
    HORIZONTAL: 'horizontal',
});

export const SNAP_POSITION = Object.freeze({
    START:  'start',
    CENTER: 'center',
    END:    'end',
});
